import React, { Component } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Error from "src/components/icons/Error";
import { ModalComponentProps } from "../../";
import MessageModal from "../MessageModal";

class UnexpectedErrorModal extends Component<ModalComponentProps & { refreshDeal: () => void } & WithTranslation> {
    public componentWillUnmount() {
        this.props.refreshDeal();
    }

    public render() {
        const { t } = this.props;

        const messageModalProps = {
            buttons: [
                {
                    onClick: () => this.props.closeModal(),
                    text: t("Modal.UnexpectedErrorModal.Button.text"),
                },
            ],
            icon: Error,
            logoDisplayed: true,
            message: t("Modal.UnexpectedErrorModal.message"),
            title: t("Modal.UnexpectedErrorModal.title"),
        };

        return <MessageModal {...messageModalProps} />;
    }
}

export default withTranslation()(UnexpectedErrorModal);
